import { patch } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useAssignCourierToOrderMutation = (customBranch?: number) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const id = useBranchId();
  const branchId = customBranch || id;

  const mutation = useMutation({
    mutationFn: ({ orderId, courierId }: any) =>
      patch(
        `/internal/secure/pos/v1/orders/information/couriers/assign/id/${branchId}/${orderId}/${courierId}`,
        {}
      ),
    onSuccess: () => {
      toast.success(t("success.update"));
      queryClient.refetchQueries({ queryKey: ["daily_orders", branchId] });
    },
  });

  return mutation;
};

export default useAssignCourierToOrderMutation;
